module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/mail-8561a71faced475ae7b03b68689b9fe1.png";